/** The vocabulary the connection activity trail uses, shared by the list and the detail page. */
export const activityActionLabels: Record<string, string> = {
  "connection.approve": "Connection approved",
  "connection.block": "Connection blocked",
  "connection.clear_credential": "Credential cleared",
  "connection.create": "Connection created",
  "connection.expiry_warning": "Credential expiry warning",
  "connection.revoke": "Connection revoked",
  "connection.rotate": "Credential rotated",
  "connection.scopes_updated": "Connection scopes changed",
  "connection.test": "Connection tested",
  "connection.tool_attach": "Tool attached",
};

export function describeActivityAction(action: string): string {
  return activityActionLabels[action] ?? "Connection activity recorded";
}

export function formatActivityTime(value: string): string {
  return new Date(value).toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
    timeZoneName: "short",
  });
}
